/**
 * Live header chrome → --site-header-height on :root.
 * Offset is the bottom edge of the bar in the viewport (not wrap height),
 * so sticky PDP gallery sits below the real overlapping header.
 */
const MQ_DESKTOP = '(min-width: 992px)';
const VAR_NAME = '--site-header-height';
const HEADER_NODES =
  '.wrapper1 > .header_wrap, .fixedHeader, .headerWrapper, .header_wrap #header, #header, #bx-panel';

function isVisible(el) {
  if (!(el instanceof HTMLElement)) {
    return false;
  }
  const style = window.getComputedStyle(el);
  if (style.display === 'none' || style.visibility === 'hidden') {
    return false;
  }
  if (parseFloat(style.opacity) === 0) {
    return false;
  }
  return true;
}

function getSiteHeaderOffset() {
  let maxBottom = 0;

  document.querySelectorAll(HEADER_NODES).forEach((el) => {
    if (!isVisible(el)) {
      return;
    }
    const rect = el.getBoundingClientRect();
    if (rect.height <= 0) {
      return;
    }
    // Covers the top of the viewport (sticky/fixed chrome).
    if (rect.bottom > 0 && rect.top < Math.max(rect.height, 1)) {
      maxBottom = Math.max(maxBottom, rect.bottom);
    }
  });

  if (maxBottom <= 0) {
    const fallback =
      document.querySelector('.fixedHeader') ||
      document.querySelector('.wrapper1 > .header_wrap') ||
      document.querySelector('#header');
    if (fallback instanceof HTMLElement) {
      maxBottom = fallback.getBoundingClientRect().height || fallback.offsetHeight || 0;
    }
  }

  return Math.max(0, Math.round(maxBottom));
}

export function initHeaderOffset() {
  const mq = window.matchMedia(MQ_DESKTOP);
  const root = document.documentElement;
  let ticking = false;

  const sync = () => {
    ticking = false;
    if (!mq.matches) {
      root.style.removeProperty(VAR_NAME);
      return;
    }
    const offset = getSiteHeaderOffset();
    if (offset > 0) {
      root.style.setProperty(VAR_NAME, `${offset}px`);
    }
  };

  const requestSync = () => {
    if (ticking) {
      return;
    }
    ticking = true;
    window.requestAnimationFrame(sync);
  };

  if (document.documentElement.dataset.headerOffsetInited === '1') {
    sync();
    return;
  }

  document.documentElement.dataset.headerOffsetInited = '1';
  sync();

  if (typeof ResizeObserver !== 'undefined') {
    const observer = new ResizeObserver(requestSync);
    document.querySelectorAll(HEADER_NODES).forEach((el) => {
      if (el instanceof HTMLElement) {
        observer.observe(el);
      }
    });
  }

  window.addEventListener('resize', requestSync, { passive: true });
  window.addEventListener('scroll', requestSync, { passive: true });
  if (typeof mq.addEventListener === 'function') {
    mq.addEventListener('change', sync);
  } else if (typeof mq.addListener === 'function') {
    mq.addListener(sync);
  }
}
